import React from 'react';
import MailThreadMessage from './MailThreadMessage';

/**
 * MailThread — renders a conversation as a vertical stack of message cards
 * (newest first), Apple-Mail / Gmail style. All messages are expanded by
 * default. Used only when a conversation has more than one message; single
 * mails keep the classic flat reading layout (handled by MailDetail).
 */
export default function MailThread({ messages }) {
  if (!messages || messages.length === 0) return null;

  return (
    <div className="ivx-thread">
      <div className="ivx-thread-count">
        {messages.length} Nachrichten in diesem Verlauf
      </div>
      {messages.map((msg, i) => (
        <MailThreadMessage
          key={`${msg._collection || 'x'}:${msg.id}`}
          message={msg}
          defaultOpen
          isLatest={i === 0}
        />
      ))}
    </div>
  );
}
